import { Injectable } from '@angular/core';
import {
  CHECK_IN_TRIP_BY,
  CheckInTextData,
  DEFAULTS,
  FORM_FIELD_IDS,
  Select,
  ToolTip
} from '@com-delta-idp/mnx-capability-check-in-ui';
import {
  DropdownItem,
  DropdownOptions
} from '@com-delta-omnichannel/mach-core-js';

@Injectable({
  providedIn: 'root'
})
export class CheckInDropdownAdapterService {
  getDropDownOptions(
    options: Select[],
    findYourTripByLabel: string
  ): DropdownOptions {
    return {
      id: FORM_FIELD_IDS.FIND_TRIP_BY,
      title: findYourTripByLabel,
      items: this.extractSelectOptions(options),
      placeholder: DEFAULTS.CONFIRMATION_NUMBER
    };
  }

  extractSelectOptions(options: Select[]): DropdownItem[] {
    return options.map((option) => ({
      label: option.label,
      value: option.value
    }));
  }

  extractSelectOption(
    options: Select[],
    toolTipData: ToolTip[]
  ): CheckInTextData[] {
    const tooltipMap = this.createTooltipMap(toolTipData);

    return options.map((option) => {
      const tooltip = tooltipMap.get(option.label);

      return {
        id: FORM_FIELD_IDS.FIND_TRIP_BY_VALUE,
        title: option.value,
        placeholder: option.placeHolder,
        inputLabel: option.inputLabel,
        modalHeader: tooltip?.title || DEFAULTS.EMPTY_STRING,
        modalContent: tooltip?.description || DEFAULTS.EMPTY_STRING
      };
    });
  }

  private createTooltipMap(toolTipData: ToolTip[]): Map<string, ToolTip> {
    const tooltipMap = new Map<string, ToolTip>();
    toolTipData.forEach((tooltip, index) => {
      if (index === 0)
        tooltipMap.set(CHECK_IN_TRIP_BY.CONFIRMATION_NUMBER, tooltip);
      if (index === 1) tooltipMap.set(CHECK_IN_TRIP_BY.TICKET_NUMBER, tooltip);
    });
    return tooltipMap;
  }
}
